export default __webpack_public_path__ + "static/media/358.5fe3f127.jpg";